import { render, staticRenderFns } from "./LocalChargeSub.vue?vue&type=template&id=6f8fa631"
import script from "./LocalChargeSub.vue?vue&type=script&lang=js"
export * from "./LocalChargeSub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f8fa631')) {
      api.createRecord('6f8fa631', component.options)
    } else {
      api.reload('6f8fa631', component.options)
    }
    module.hot.accept("./LocalChargeSub.vue?vue&type=template&id=6f8fa631", function () {
      api.rerender('6f8fa631', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/LocalChargeSub.vue"
export default component.exports